// Bella Vita — Arabic strings (primary language).
// Merged from design-v2/js/booking-demo.js + account-demo.js i18n tables.
// Structurally maintainable: plain nested object, expanded per screen as
// implementation proceeds.
export default {
  _dir: 'rtl',
  _name: 'العربية',

  common: {
    book: 'احجزي',
    book_appointment: 'احجزي موعدك',
    browse_services: 'تصفّحي الخدمات',
    next: 'متابعة',
    back: 'رجوع',
    edit: 'تعديل',
    add: 'إضافة',
    added: 'مضافة',
    details: 'التفاصيل',
    remove: 'إزالة',
    retry: 'إعادة المحاولة',
    done: 'تم',
    loading: 'جارٍ التحميل…',
    error_generic: 'تعذّر تحميل المحتوى. تحقّقي من الاتصال وحاولي مجدداً.',
    empty_generic: 'لا يوجد شيء لعرضه بعد.',
    min: 'دقيقة',
    from: 'يبدأ من',
    skip_to_content: 'تخطَّ إلى المحتوى',
    account: 'حسابي',
  },

  nav: { home: 'الرئيسية', services: 'الخدمات', about: 'من نحن', contact: 'تواصلي' },

  booking: {
    party_title: 'عدد الأشخاص',
    party_sub: 'كم شخصاً في هذا الحجز؟ (بحدٍّ أقصى ٤)',
    person: 'الشخص',
    add_person: 'إضافة شخص',
    person_one: 'شخص',
    person_other: 'أشخاص',
    services_title: 'اختيار الخدمات',
    services_sub: 'اختاري الخدمات لكل شخص. تظهر «خدماتي» في الملخّص.',
    myservices: 'خدماتي',
    specialist_title: 'اختيار الأخصائية',
    specialist_sub: 'اختاري من تفضّلين، أو اتركيها «بدون تفضيل».',
    any_specialist: 'بدون تفضيل',
    specialist_role: 'أخصائية',
    date_title: 'اختيار التاريخ',
    date_sub: 'التقويم يعرض الأيام المتاحة في بيلا فيتا.',
    cal_prev_month: 'الشهر السابق',
    cal_next_month: 'الشهر التالي',
    cal_selected: 'مختار',
    cal_has_slots: 'متاح',
    cal_today: 'اليوم',
    slots_empty: 'لا أوقات متاحة في هذا اليوم.',
    time_title: 'اختيار الوقت',
    time_sub: 'الأوقات المتاحة لليوم المختار.',
    customer_title: 'بياناتك',
    customer_sub: 'نحتاج رقم جوّالك وبريدك لإنشاء حساب Odoo Portal وإدارة الحجز.',
    review_title: 'مراجعة الحجز',
    review_sub: 'تأكّدي من التفاصيل قبل الدفع.',
    pick_service_first: 'اختاري خدمة واحدة على الأقل للمتابعة.',
    added: 'أُضيفت إلى خدماتي',
    step_party: 'الأشخاص', step_services: 'الخدمات', step_specialist: 'الأخصائية',
    step_date: 'التاريخ', step_time: 'الوقت', step_customer: 'بياناتك', step_review: 'مراجعة',
    party_hint: 'يمكنكِ إسناد خدمات مختلفة لكل شخص في الخطوة التالية.',
    all_categories: 'الكل',
    time_pick_date_first: 'اختاري التاريخ أولاً.',
    name_label: 'الاسم', name_ph: 'الاسم الكامل',
    mobile_label: 'رقم الجوّال',
    email_label: 'البريد الإلكتروني',
    notes_label: 'ملاحظات (اختياري)', notes_ph: 'أي تفاصيل تساعد الفريق',
    sms_hint: 'سنرسل تأكيد الحجز عبر رسالة نصية.',
    no_account_hint: 'لتأكيد الحجز ستسجّلين الدخول أو تنشئين حساب Bella Vita عبر نظام Odoo الآمن.',
    review_specialist: 'الأخصائية', review_appointment: 'الموعد', review_your_details: 'بياناتك',
    step_progress: 'خطوة',
    morning: 'صباحاً', afternoon: 'بعد الظهر', evening: 'مساءً',
    promo_title: 'كود الخصم', promo_placeholder: 'أدخلي الكود', promo_apply: 'تطبيق', promo_remove: 'إزالة', promo_applied: 'تم تطبيق الخصم', promo_invalid: 'كود الخصم غير صالح أو غير متاح لهذا الحجز.',
    subtotal: 'المجموع الفرعي', discount: 'الخصم',
    vat: 'ضريبة القيمة المضافة',
    total: 'الإجمالي',
    duration: 'المدة',
    deposit: 'المبلغ المطلوب الآن',
    pay_at_salon: 'الباقي في الصالون',
  },

  account: {
    login_title: 'تسجيل الدخول',
    guest_cta: 'المتابعة كضيف',
    my_bookings: 'حجوزاتي',
    upcoming: 'القادمة',
    past: 'السابقة',
    profile: 'الملف الشخصي',
    ref: 'رقم الحجز',
    with: 'مع',
    view_booking: 'عرض الحجز',
    status_upcoming: 'قادم',
    status_completed: 'مكتمل',
    status_confirmed: 'مؤكّد',
    status_cancelled: 'ملغى',
    welcome: 'أهلاً',
    account_home: 'حسابي',
    total_bookings: 'إجمالي الحجوزات',
    member: 'عضوة بيلا فيتا',
    book_new: 'احجزي موعداً جديداً',
    none_upcoming: 'لا مواعيد قادمة',
    none_bookings: 'لا توجد حجوزات بعد',
    logout: 'تسجيل الخروج',
    booking_detail: 'تفاصيل الحجز',
    reschedule: 'إعادة جدولة',
    cancel_booking: 'إلغاء الحجز',
    cancel_confirm_title: 'إلغاء الحجز؟',
    cancel_confirm_body: 'سيتم إلغاء هذا الموعد ولا يمكن التراجع.',
    cancel_confirm_cta: 'تأكيد الإلغاء',
    keep: 'الاحتفاظ بالحجز',
    cancelled_toast: 'تم إلغاء الحجز',
    book_again: 'احجزي مجدداً',
    when: 'الموعد',
    filter_all: 'الكل',
    sync_note: 'مزامنة داخلية مع تقويم بيلا فيتا فقط.',
    profile_title: 'الملف الشخصي',
    profile_note: 'تعديل البيانات الشخصية سيتوفّر لاحقاً.',
    gate: 'سجّلي الدخول للوصول إلى حسابك.',
  },


  checkout: {
    header: 'إتمام الحجز', header_sub: 'مراجعة ودفع',
    title: 'مراجعة الحجز', sub: 'تأكّدي من التفاصيل ثم اختاري طريقة الدفع.',
    blk_services: 'خدماتي', blk_appt: 'الموعد والأخصائية', blk_customer: 'العميلة',
    date: 'التاريخ', time: 'الوقت', specialist: 'الأخصائية',
    terms: 'أوافق على سياسة الحجز والإلغاء وشروط بيلا فيتا.',
    to_pay: 'المتابعة إلى الدفع', pay_short: 'الدفع', agree_first: 'يرجى الموافقة على الشروط.',
    incomplete: 'أكملي خطوات الحجز أولاً.',
  },

  payment: {
    header: 'الدفع', header_sub: 'إتمام دفع الحجز',
    method_title: 'طريقة الدفع',
    method_sub: 'يُدفع مبلغ الخدمات كاملًا لتأكيد الحجز.',
    pay_deposit: 'ادفعي الآن', pay_short: 'ادفعي',
    confirm_no_pay: 'تأكيد بدون دفع الآن',
    choose_method: 'اختاري طريقة دفع.',
    failed: 'تعذّر إتمام الحجز. حاولي مجدداً.',
    provider_failed: 'تم حفظ موعدك مؤقتًا، لكن تعذّر فتح بوابة الدفع. حاولي الدفع مجددًا.',
    method_unavailable: 'طريقة الدفع المختارة لم تعد متاحة لهذا الحجز.',
    retry_payment: 'تم حفظ الحجز، لكن الدفع لم يكتمل. يمكنك إعادة محاولة الدفع دون إنشاء حجز جديد.',
    secure_note: 'الدفع يتم في صفحة مزود الدفع الآمنة. بيلا فيتا لا تجمع أو تحفظ بيانات بطاقتك.',
    mock_note: 'واجهة عرض فقط — لا يتم تحصيل أي مبلغ ولا تُجمع بيانات بطاقة في هذا النموذج.',
    auth_invite: 'بياناتك مرتبطة بسجل عميلة موجود. فعّلي حساب Odoo Portal على نفس السجل حتى تبقى حجوزاتك كلها في حساب واحد.',
    auth_invite_cta: 'إرسال رابط تفعيل الحساب',
    auth_invite_sent: 'تم إرسال رابط التفعيل إلى البريد المسجل. بعد تعيين كلمة المرور، سجّلي الدخول للعودة إلى الحجز.',
    auth_login_cta: 'تسجيل الدخول',
    auth_conflict: 'تعذّر مطابقة البيانات بأمان مع حساب واحد. استخدمي تسجيل الدخول أو استعادة كلمة المرور، أو تواصلي مع الصالون.',
    auth_reset_cta: 'استعادة كلمة المرور',
    auth_invite_failed: 'تعذّر إرسال رابط التفعيل بأمان. استخدمي تسجيل الدخول أو استعادة كلمة المرور.',
  },

  confirmation: {
    header: 'تم التأكيد',
    title: 'تم تأكيد حجزك',
    texted: 'أرسلنا التفاصيل عبر رسالة نصية إلى',
    appt_details: 'تفاصيل الموعد',
    date_time: 'التاريخ والوقت',
    deposit_paid: 'العربون المدفوع',
    payment_status: 'حالة الدفع',
    payment_verifying: 'جارٍ التحقق من الدفع…',
    payment_paid: 'تم الدفع بنجاح',
    payment_failed: 'لم يكتمل الدفع',
    payment_pending: 'الدفع قيد التحقق',
    retry_payment: 'إعادة محاولة الدفع',
    account_home: 'حسابي',
    book_again: 'احجزي مجدداً',
    sync_note: 'يُزامَن الموعد داخلياً مع تقويم بيلا فيتا. لا يظهر أي تقويم خارجي.',
    none_title: 'لا يوجد حجز لعرضه',
    none_cta: 'احجزي موعداً',
  },

  notfound: { title: 'الصفحة غير موجودة', cta: 'العودة إلى الرئيسية' },

  footer: {
    tagline: 'صالون واحد. تجربة عناية هادئة ومتقنة في قلب المدينة.',
    explore: 'روابط',
    services: 'الخدمات',
    book: 'احجزي موعد',
    account: 'حسابي',
    salon: 'الصالون',
    address: 'العنوان — بيانات المالك',
    hours: 'أوقات العمل — بيانات المالك',
    contact: 'تواصلي',
    phone: 'هاتف / واتساب — بيانات المالك',
    instagram: 'إنستغرام — بيانات المالك',
    rights: '© 2026 بيلا فيتا',
    one_salon: 'صالون واحد',
  },

  home: {
    hero_eyebrow: 'صالون بيلا فيتا',
    hero_title: 'جمالٌ تستحقينه، بهدوء وإتقان',
    hero_sub: 'احجزي موعدك في دقائق. اختاري خدماتك، الأخصائية، والوقت الذي يناسبك.',
    cta_book: 'احجزي موعدك',
    cta_services: 'تصفّحي الخدمات',
    why_eyebrow: 'لماذا بيلا فيتا',
    why_lead: 'مساحة واحدة، فريق واحد، ومعايير عالية في كل تفصيل.',
    value_1: 'حجز فوري ومرن',
    value_2: 'أخصائيات مختارات بعناية',
    value_3: 'منتجات راقية وآمنة',
    collections_eyebrow: 'الخدمات',
    collections_title: 'مجموعات العناية لدينا',
    all_services: 'كل الخدمات',
    clients_title: 'مشاركات العميلات',
    quote: '«تجربة هادئة ومنظّمة من الحجز حتى نهاية الجلسة.»',
    quote_cite: 'عميلة بيلا فيتا',
  },

  services: {
    eyebrow: 'الخدمات',
    title: 'قائمة الخدمات والأسعار',
    lead: 'الأسعار بالريال السعودي، شاملة ضريبة القيمة المضافة حيثما تنطبق. الأرقام بالخانات اللاتينية.',
    all: 'الكل',
    count_suffix: 'خدمات',
    empty: 'لا توجد خدمات في هذا القسم بعد.',
  },

  detail: {
    desc: 'جلسة عناية متكاملة يقدّمها فريق بيلا فيتا بمنتجات مختارة.',
    fact_from: 'يبدأ من',
    fact_daily: 'يومياً',
    fact_availability: 'التوفّر',
    book_this: 'احجزي هذه الخدمة',
    back: 'رجوع',
    includes_title: 'ماذا تتضمّن الجلسة',
    include_1: 'استشارة قصيرة قبل البدء',
    include_2: 'منتجات مختارة للعناية',
    include_3: 'خطوات معقّمة وأدوات نظيفة',
    include_4: 'نصائح للعناية بعد الجلسة',
    not_found: 'الخدمة غير موجودة',
  },
};
